import {Unsubscribable} from '@core/interfaces/unsubscribable';
import {BehaviorSubject, Subscription} from 'rxjs';
import {FilterState} from '@theme/components';
import {FormBuilder} from '@angular/forms';

export interface FiltersFullState {
    [fieldKey: string]: FilterState;
}

export abstract class FilterAccordion extends Unsubscribable {
    protected changeSubscription: Subscription;
    protected searchSubscription: Subscription;

    protected formGroupValue = new BehaviorSubject(null);

    constructor(public fb: FormBuilder) {
        super();
    }
}
